// Config Dev
// export const FIREBASE_CONFIG = {
//   apiKey: 'AIzaSyCY2XpMjje3gLltY4WOHDBkJr-ZmigCbfs',
//   authDomain: 'atmost-dev.firebaseapp.com',
//   projectId: 'atmost-dev',
//   storageBucket: 'atmost-dev.appspot.com',
//   messagingSenderId: '267112153793',
//   appId: '1:267112153793:web:2a9c6659c9873b632b8a40',
//   measurementId: 'G-YGQ9XWK4JF'
// };
// export const CLOUDFUNC_DOMAIN = 'https://us-central1-atmost-dev.cloudfunctions.net';

// export const MAIL_DOMAIN = '@atmostbogor.com';
// export const CLOUDFUNC_DOMAIN = 'https://us-central1-atmost-bogor.cloudfunctions.net';

//  Config Site
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBSuS3iSTiSwwsNPFtAl0YRZ9nqM04nmT4',
  authDomain: 'atmost-hasto.firebaseapp.com',
  projectId: 'atmost-hasto',
  storageBucket: 'atmost-hasto.firebasestorage.app',
  messagingSenderId: '258789498624',
  appId: '1:258789498624:web:5bc60f696898c9f4205de5',
};

export const multilevelApprovalSite = ['atmost-parigi'];

export const outsideAssignmentWithTypeSite = ['atmost-cibinong'];

export const doubleHospitalRadiusSite = [
  'si-abah',
  'atmost-cibabat',
  'atmost-parigi',
  'atmost-serang',
  'atmost-pakuhaji',
  'atmost-palabuhanratu',
];
